export default {
  app: {
    privacy: {
      policy: '隐私政策',
      expansive: '使用Expansive即表示您同意Expansive的{action}',
      client: '@:app.privacy.expansive{lineBreak}& {clientName} {clientAction}',
    },
    sessionExpired: '会话已过期',
    sessionExpiredDescription: '您的会话已过期。请重新登录以继续使用该应用程序。',
  },
  components: {
    appContainer: {
      chooseLanguage: '选择语言',
      chooseLanguageDescription: '选择您偏好的应用程序语言。这将更改界面和内容的语言。',
    },
    userSelection: {
      cancel: '取消',
      createNewUser: '没有他们的名字',
      newUser: '新用户',
      selectAnExistingUser: '选择现有用户',
      selectUserHint: '选择现有用户或创建新用户以继续。',
      startTypingToSearch: '开始输入...',
    },
    verification: {
      codeVerification: {
        continue: '继续',
        header: '输入现场访问码',
        invalidCode: '验证码无效，请重试。',
      },
      geoVerification: {
        continueWithoutVerifying: '无需验证位置继续',
        enterSiteAccessCode: '输入现场访问码',
        locationNotEnabledOrAvailable: '为什么我会看到这个？',
        notAvailable: {
          description: '此设备不支持GPS位置。',
          header: '位置不支持',
        },
        notEnabled: {
          description: '位置服务未启用或未授予权限。',
          header: '位置未启用',
        },
        notVerified: {
          description: 'GPS显示您不在现场。',
          header: '位置未验证',
        },
        tryAgain: '重试',
        unavailable: {
          description: '我们无法验证您的GPS位置。',
          header: '位置不可用',
        },
        unknown: {
          description: '我们无法确定您的位置。',
          header: '位置未知',
        },
        verified: {
          description: 'GPS显示您在现场。',
          header: '位置已验证',
        },
      },
    },
    workOrder: {
      assets: {
        emptyTitle: '未找到资产',
        emptyDescription: '此工单未关联任何资产。',
        warrantyParts: '零件保修到期',
        serialNumber: '序列号',
        none: '<无>',
      },
      updates: {
        emptyTitle: '未找到更新',
        emptyDescription: '此工单没有更新。',
        unknownUser: '未知用户',
        none: '无',
        addComment: {
          buttonLabel: '添加评论',
        },
      },
      startWorkCheck: {
        startWorkCheckList: {
          hazards: '危害',
          no: '否',
          yes: '是',
        },
      },
    },
    attachmentsList: {
      attachments: '附件',
      documents: '文件',
      siteDocuments: '现场文件',
    },
  },
  stores: {
    authenticated: {
      startWorkCheckStore: {
        hazards: '危害',
        induction: '入职培训',
        safeToProceed: '可以继续',
      },
    },
  },
  views: {
    authenticated: {
      sessions: {
        dueBy: '到期日期',
        activeSessions: '活跃会话',
        activeSessionsDescription:
          '您已在以下工单中签到。您必须先在这些工单中签出，然后才能签到新工单。',
        resumeSession: '恢复',
        startTime: '开始于',
        unexpectedErrorTitle: '意外错误',
        unexpectedErrorMessage: '尝试创建会话时发生意外错误。请稍后再试。',
        engineerNotFound: '找不到工程师',
        engineerNotFoundDescription: '您尝试签到的工程师在系统中未找到。请联系管理员。',
      },
      verification: {
        code: {
          description: '要签到，请从现场经理或指定联系人处获取4位数字代码。',
        },
        geo: {
          continue: '继续',
        },
      },
      workOrders: {
        checkout: {
          index: {
            signOff: '请向现场经理或指定联系人获取访问码以完成您的访问。',
            checkOut: '签出',
            completeBeforeLeaving: '离开前请填写以下表格。',
            continue: '继续',
            noResolutionSelected: '请在继续之前选择一个解决方案。',
            quoteRequired: {
              hint: '访问完成，报价随后提供',
              label: '需要报价',
            },
            returnVisitRequired: {
              hint: '我们将再次返回以完成',
              label: '需要返回访问',
            },
            serviceCompleted: {
              hint: '无需进一步操作',
              label: '服务已完成',
            },
            uploadCheckout: '上传文件、照片或视频',
            visitNotes: '访问备注',
            workOrderResolution: '工单解决方案',
            enterNotes: '在此输入任何备注...',
            errors: {
              timedOut: '超时，已超过30秒。请重试。',
              closingSession: '关闭会话时出错',
            },
          },
          success: {
            description:
              '感谢您访问 {site}。| {site} 仍有 1 个未完成的工单。| {site} 仍有 {count} 个未完成的工单。',
            endVisit: '结束访问',
            header: '您已成功签出',
            viewWorkOrders: '签到另一个工单',
          },
          verification: {
            code: {
              description: '要签出，请从现场经理或指定联系人处获取4位数字代码。',
              continue: '继续',
            },
            geo: {
              checkOut: '签出',
              continue: '继续',
            },
          },
        },
        detail: {
          assets: '资产',
          call: '呼叫',
          checkOut: '签出',
          closed: '已关闭',
          details: '详情',
          dueBy: '到期日期',
          manageEngineers: '管理工程师',
          notAvailable: '不可用',
          pointOfContact: '联系人',
          siteAccessTimes: '现场访问时间',
          siteAccessInstructions: '访问说明',
          siteAddress: '现场地址',
          siteNotes: '现场备注',
          siteTelephone: '现场电话',
          siteLocation: '现场位置',
          updates: '更新',
          more: '更多',
          mismatchErrorTitle: '工单错误',
          mismatchErrorMessage: '您尝试访问的工单与您当前签到的工单不匹配。请检查您的工单并重试。',
          siteDocuments: '现场文件',
          validFrom: '有效期从',
          validUntil: '有效期至',
          documentName: '文件名',
          documentType: '文件类型',
          attachments: '工单文件',
          download: '下载',
          workDetails: '工作详情',
        },
        engineers: {
          assistants: {
            addAssistantEngineer: '添加助理工程师',
            assistantEngineers: '助理工程师',
            description: '出于安全原因，请指定现场每位工程师的姓名。',
            editMainEngineer: '编辑主工程师',
            errors: {
              creatingEngineer: '创建工程师时出错',
              creatingSession: '创建会话时出错',
            },
            header: '现场工程师',
            mainEngineer: '主工程师',
            newAssistantEngineer: '输入他们的全名',
            next: '下一步',
            removeEngineer: '移除工程师',
            selectExistingAssistantEngineer: '开始输入他们的名字',
          },
          index: {
            description: '出于安全原因，请指定现场每位工程师的姓名。',
            errorCreatingEngineer: '创建工程师时出错，请重试。',
            header: '现场工程师',
            hintMainEngineer: '输入主工程师的全名',
            newMainEngineer: '新主工程师',
            next: '下一步',
            selectExistingMainEngineer: '选择现有主工程师',
            yes: '是',
            no: '否',
            mainEngineerLabel: '您是主工程师吗？',
          },
        },
        index: {
          callUsOn: '拨打我们的电话 {phoneNumber}',
          description: '找不到您要找的内容？',
          dueBy: '到期日期',
          header: '选择工单',
          notAvailable: '不可用',
          searchWorkOrders: '搜索工单...',
        },
        manageEngineers: {
          manageEngineers: '管理工程师',
          notWorking: '非活跃工人',
          pause: '暂停',
          resume: '恢复',
          workingNow: '活跃工人',
          startTime: '开始时间',
          endTime: '结束时间',
          duration: '持续时间',
        },
        startWorkChecks: {
          feedback: {
            feedbackTitle: '反馈',
            feedbackDescription: '请对工单提供反馈，以帮助我们改善服务。',
            feedbackLabel: '反馈',
            filesLabel: '附件',
            submissionLabel: '提交反馈',
          },
          hazards: {
            back: '返回',
            hazards: '危害',
            next: '下一步',
            no: '否',
            noTasksForHazard: '此危害没有要完成的任务。',
            yes: '是',
          },
          induction: {
            continue: '继续',
            induction: '入职培训',
          },
          index: {
            checkIn: '签到',
            description: '请完成所选工作的风险评估。',
            fail: '处理开始工单检查时失败。',
            haltMessage: '检测到潜在风险。请停止工作，查看安全指南，并联系主管获取进一步指示。',
            header: '开始工作检查',
            endVisit: '结束访问',
            leaveFeedback: '留下反馈',
          },
          safeToProceed: {
            continue: '继续',
            safeToProceed: '可以继续',
          },
        },
      },
    },
    index: {
      title: '欢迎',
      description: '扫描您所在位置的二维码以开始。',
    },
    login: {
      errorTitle: '意外错误',
      errorMessage: '发生意外错误。请再次尝试扫描二维码。',
    },
    unauthenticated: {
      welcome: {
        title: '欢迎来到 {site}',
        description: '在向您显示任何工单之前，我们需要验证您的详细信息。点击下面的按钮继续。',
        next: '继续',
      },
      index: {
        errorTitle: '意外错误',
        errorMessage: '发生意外错误。请再次尝试扫描二维码。',
      },
      contractor: {
        title: '您为谁工作？',
        contractor: '承包商',
        contractorLabel: '开始输入您的公司名称',
        contractorHint: '您必须输入三个或更多字符才能查看结果',
        defaultSelectPlaceholder: '--请选择--',
        next: '下一步',
      },
      user: {
        title: '您是谁？',
        cancel: '取消',
        createNewUserLabel: '我的名字不在列表中',
        existingUserLabel: '开始输入您的名字',
        existingUserHint: '您必须输入三个或更多字符才能查看结果',
        newUserLabel: '输入您的全名',
        next: '下一步',
        user: '用户',
      },
      verification: {
        methods: {
          add: {
            add: '添加验证方式',
            defaultSelectPlaceholder: '--请选择--',
            emailLabel: '电子邮件',
            existingMethodWarning:
              '您已经有一个待处理的请求用于此验证方式，等待管理员批准。添加新验证方式将覆盖原有请求。',
            method: '方式',
            methodLabel: '方式',
            mobileCountryHint: '请选择您的国家代码',
            mobileCountryLabel: '手机国家代码',
            mobileHint: '请输入您的手机号码',
            mobileLabel: '手机',
            title: '添加验证方式',
          },
          confirm: {
            confirm: '确认',
            description: '请确认您的验证方式以继续。',
            label: '输入您的代码',
            resend: '重新发送',
            resendPrompt: '没有收到代码？',
            title: '确认验证方式',
          },
          confirmed: {
            description: '一旦管理员批准了此验证方式，您将收到通知，然后可以使用它来验证您的身份。',
            forceApproval: '在获得批准之前，您将无法访问工单。',
            nonForceApproval: '在此期间，您可以继续以有限的访问权限访问工单。',
            nonForceApprovalButtonLabel: '继续有限访问',
            title: '等待批准',
          },
          addNew: '添加新验证方式',
          description: '我们需要验证您的身份，以便为您提供对工单的完全访问权限。',
          email: '电子邮件',
          hint: '我们将向您选择的验证方式发送一个链接，您可以通过该链接完全访问工单。如果您需要更改任何现有的验证方式，请联系管理员。',
          label: '选择验证方式',
          next: '下一步',
          pendingHint: '等待管理员批准',
          sms: '短信',
          title: '验证',
        },
        optional: {
          hint: '验证您的用户详细信息将使您获得对工单的完全访问权限',
          label: '您想验证您的用户详细信息吗？',
          next: '下一步',
          no: '不',
          noHint: '我不想验证我的用户详细信息，继续以有限的访问权限访问工单',
          title: '验证',
          yes: '是',
          yesHint: '我想验证我的用户详细信息，获得对工单的完全访问权限',
        },
        sent: {
          description: '登录链接已发送至 {identifier}。请点击链接完成登录。',
          title: '登录链接已发送',
        },
      },
    },
  },
  utils: {
    getActivityLog: {
      yesterday: '昨天',
      today: '今天',
      days: {
        monday: '星期一',
        tuesday: '星期二',
        wednesday: '星期三',
        thursday: '星期四',
        friday: '星期五',
        saturday: '星期六',
        sunday: '星期天',
      },
      months: {
        january: '一月',
        february: '二月',
        march: '三月',
        april: '四月',
        may: '五月',
        june: '六月',
        july: '七月',
        august: '八月',
        september: '九月',
        october: '十月',
        november: '十一月',
        december: '十二月',
      },
    },
  },
  composables: {
    useRedirectToError: {
      title: '出现问题',
      message: '请再次尝试扫描二维码。',
    },
    useResolveWorkOrderEvents: {
      user: {
        unknown: '未知用户',
      },
      none: '无',
      types: {
        stateTransition: '状态更改',
        contractorAssigned: '分配承包商',
        engineerAssigned: '分配工程师',
        serviceAssigned: '分配服务',
        priorityChanged: '优先级更改',
        actionableDateChanged: '可操作日期更改',
        dueDateChanged: '到期日期更改',
        etaDateChanged: '预计到达时间更改',
        spendLimitApproved: '支出限额已批准',
        spendLimitCancelled: '支出限额请求已取消',
        spendLimitRejected: '支出限额已拒绝',
        spendLimitRequested: '已请求支出限额',
        jobSheetUploaded: '作业单已上传',
        slaAlertSent: '发送了违反SLA警报的响应时间',
        issuedWorkPermit: '已发放工作许可证',
        requestForServiceSent: '已发送服务请求',
        comment: '已添加评论',
        unknown: '未知事件',
      },
      labels: {
        actionableDate: '可操作日期',
        comment: '评论',
        file: '文件',
        contractor: '承包商',
        dueDate: '到期日期',
        etaDate: '预计到达时间',
        engineer: '工程师',
        priority: '优先级',
        requestForService: '服务请求',
        service: '服务',
        spendLimit: '支出限额',
        status: '状态',
        workPermit: '工作许可证',
      },
    },
  },
}
